import { useMemo, useState } from "react";
import { axiosGetWithHeader, axiosPostWithHeader, ShowAlertError } from "../Common/axios";
import { AppHeader } from "./AppHeader";
import { useLocation } from "react-router-dom";
import Spinner from 'react-bootstrap/Spinner';
import { AppFooter } from "./AppFooter";

import { AstrologerInfoFooter } from "../Common/AstrologerInfoFooter";
import { BirthTimeCorrectionPageMenu } from "./BirthTimeCorrectionPageMenu";
import { BirthTimeCorrectionTab } from "./Basic/BirthTimeCorrectionTab";
import { TransitCuspalInIntervalTab } from "./Basic/TransitCuspalInIntervalTab";
import { TransitPlanetInIntervalTab } from "./Basic/TransitPlanetInIntervalTab";

export function BirthTimeCorrectionPage()  {
  const {state} = useLocation();
  const runningId = state?state.runningId:null;
  const [userData, setUserData] = useState(null);
  const [menuArray, setMenuArray] = useState([]);
  const [spinner, setSpinner] = useState('Loading - Client Details Page');
  const [errorAlert, setErrorAlert] = useState(null);
  const handleMenu = (menuArray)=>setMenuArray(menuArray);
  const [transitIntervalData, setTransitIntervalData] = useState([]);
  const [date, setDate] = useState([]);
  const [startTime, setStartTime] = useState([]);
  const [endTime, setEndTime] = useState([]);

  useMemo(() => {
    axiosGetWithHeader("/userrequest/"+runningId,
      (response)=>{
        setUserData(response.data);
        getTransitInInterval({"runningId":runningId});
        setSpinner(null);
      },
      (error)=>{
        setUserData(null);
        setSpinner(null);
        console.log(error);
        setErrorAlert(error.message);
      }
    );
  }, [runningId]);

  function getUserRequest(runningId) {
    axiosGetWithHeader("/userrequest/"+runningId,
      (response)=>{
        setUserData(response.data);
        getTransitInInterval({"runningId":runningId});
        setSpinner(null);
      },
      (error)=>{
        setUserData(null);
        setSpinner(null);
        console.log(error);
        setErrorAlert(error.message);
      }
    );
  }

  function getTransitInInterval(requestdata) {
    axiosPostWithHeader("/chart/dateintervalsearch", requestdata,
      (response)=>{
        setTransitIntervalData(response.data);
        setDate(response.data.startDate.substring(0,10));
        setStartTime(response.data.startDate.substring(11));
        setEndTime(response.data.endDate.substring(11));
      },
      (error)=>{
        console.log(error);
        setTransitIntervalData(null);
        setDate(null);
        setStartTime(null);
        setEndTime(null);
      }
    );
  }

  const handleCalculate = (startTime,endTime)=>{
    if(startTime===null||startTime===undefined||endTime===null||endTime===undefined) return;
    const requestdata = {
      "runningId":runningId,
      "startDate":date+"T"+startTime+(startTime.length===5?":00":""),
      "endDate":date+"T"+endTime+(endTime.length===5?":00":"")
    }
    getTransitInInterval(requestdata);
  }

  return (
    <>
        <div class="m-0 p-0 row sticky-top bg-white noprint">
            <div class="m-0 p-0 col-12">
                <AppHeader/>
                <BirthTimeCorrectionPageMenu userData={userData} handleMenu={handleMenu} />
            </div>    
        </div> 
        {spinner===null?<></>:<div class="text-center text-primary h5 pt-5">{spinner} <Spinner animation="border" size="sm" /></div>}
        { userData===null || userData===undefined || userData.length===0?<div class="menupageheight"></div>:
        <>
        <div class="m-0 p-0 row align-items-top">
            <div class="m-0 p-0 col-12">
              <div class="menupageheight">
                <BirthTimeCorrectionTab menuArray={menuArray} menuIndex="0" userData={userData} getUserRequest={getUserRequest} />
                <TransitCuspalInIntervalTab menuArray={menuArray} transitIntervalData={transitIntervalData} date={date} startTime={startTime} endTime={endTime} setDate={setDate} setStartTime={setStartTime} setEndTime={setEndTime} handleCalculate={handleCalculate}/>
                <TransitPlanetInIntervalTab menuArray={menuArray} transitIntervalData={transitIntervalData} date={date} startTime={startTime} endTime={endTime} setDate={setDate} setStartTime={setStartTime} setEndTime={setEndTime} handleCalculate={handleCalculate}/>
              </div>  
            </div>
        </div>
        </>}
        <div class="m-0 p-0 row noprint">
            <div class="m-0 p-0 col-12">
                <AppFooter/>
            </div>    
        </div>
        <div class="m-0 p-0 row d-none d-print-block printfooter">
          <div class="m-0 p-0 col-12">
            <AstrologerInfoFooter userData={userData}  />
          </div>    
        </div> 
        <ShowAlertError errorAlert={errorAlert} setErrorAlert={setErrorAlert}/>
    </>
  );
}
